/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-04-11.
 */


'use strict';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { LKContextMenuDirective } from './directive';
import { LKContextMenuComponent } from './component';
import { LKContextMenuService } from './service';
import { CommonModule } from '@angular/common';
import { ContextElementDirective } from './element';
import { LKIcon } from '../icon/module';

@NgModule({
  imports       : [
    CommonModule,
    LKIcon
  ],
  declarations  : [LKContextMenuDirective, LKContextMenuComponent, ContextElementDirective],
  exports       : [LKContextMenuDirective, LKContextMenuComponent],
  providers     : [LKContextMenuService],
  schemas       : [NO_ERRORS_SCHEMA]
})
export class LKContextMenu {}
